var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.992 4.171 12 4.167l.009.004 4.453 2.672L18 7.77V18.8c0 .593-.001.918-.02 1.15l-.003.027-.026.002c-.233.02-.558.021-1.15.021H7.2c-.594 0-.918-.002-1.152-.02l-.026-.003-.002-.026C6 19.718 6 19.393 6 18.8V7.77l1.531-.923 4.46-2.676Zm-5.49.962-5.016 3.01a1 1 0 1 0 1.029 1.714L4 8.967V18.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V8.966l1.486.891a1 1 0 1 0 1.029-1.715L17.493 5.13l-3.841-2.314c-.28-.168-.494-.297-.676-.394a2.001 2.001 0 0 0-.129-.067 1.839 1.839 0 0 0-.416-.152 2 2 0 0 0-.861 0c-.135.03-.267.079-.418.153-.043.02-.085.042-.127.065-.182.097-.396.226-.676.395L6.502 5.133Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 20v-4a1 1 0 1 0-2 0v4h2Zm-1-7a3 3 0 0 0-3 3v6h6v-6a3 3 0 0 0-3-3Z",
    fill: "#777E91"
  })));
};
export default SvgLine;